module.exports = __webpack_public_path__ + "img/Primordial-Process-2-mobile.831b1507.png";